/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgentAvatarIssueViewCommentsRelayProvider = {
	get(): boolean {
		return fg('jira_ai_agent_avatar_issue_view_comments');
	},
};

export default JiraAiAgentAvatarIssueViewCommentsRelayProvider;
